import Icon from '../../Utilites/Icon';

import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';



const AudioSelectPlay = ({ question, handleAnswer, answerStatus }) => {
    const { t } = useTranslation();
    const [selectedIndexes, setSelectedIndexes] = useState([]);
    const audioRef = useRef(null);
    const answered = answerStatus !== null && answerStatus !== undefined;

    // No hard limit — user may select any number of options (including all correct answers)
    const handleImageClick = (idx) => {
        if (answered) return;
        setSelectedIndexes((prev) => {
            let next;
            if (prev.includes(idx)) {
                next = prev.filter((i) => i !== idx);
            } else {
                next = [...prev, idx];
            }
            return next;
        });
    };

    const handlePlayAudio = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current.play();
        }
    };

    const handleSubmit = () => {
        const selectedWords = selectedIndexes.map((i) => question.optionsWords[i]);
        handleAnswer(selectedWords, question);
    };

    return (
        <div className="audio-select-play flex flex-col items-center">
            <div className="my-6 text-center">
                <h2 className="question text-2xl font-bold text-primary mb-2">{t('quiz-10-question')}</h2>
            </div>
            <div className="flex justify-center mb-8">
                {question.audio && (
                    <>
                        <audio ref={audioRef} src={question.audio} />
                        <button
                            className="btn-primary px-6 py-3 rounded-full shadow-lg text-lg flex items-center gap-2 hover:bg-primary-600 transition"
                            onClick={handlePlayAudio}
                            aria-label={t('play-sound')}
                        >
                            <Icon name="volume_up" className="text-2xl" /> {t('play-sound-again')}
                        </button>
                    </>
                )}
            </div>
            <div className="audioselect-options flex flex-wrap gap-4 w-full max-w-4xl justify-center">
                {question.options.map((img, idx) => {
                    let borderClass = 'border-gray-300';
                    let bgClass = 'bg-white';
                    let shadowClass = 'shadow-md';
                    if (selectedIndexes.includes(idx) && !answered) {
                        borderClass = 'border-blue-400';
                        bgClass = 'bg-blue-50';
                        shadowClass = 'shadow-lg';
                    }
                    if (answered && selectedIndexes.includes(idx)) {
                        const selectedWord = question.optionsWords[idx];
                        const isSelectedCorrect = question.correctAnswers.includes(selectedWord);
                        if (isSelectedCorrect) {
                            borderClass = 'border-green-500';
                            bgClass = 'bg-green-50';
                        } else {
                            borderClass = 'border-red-500';
                            bgClass = 'bg-red-50';
                        }
                    }
                    return (
                        <div
                            key={idx}
                            className={`transition-all duration-200 rounded-2xl border-4 ${borderClass} ${bgClass} ${shadowClass} flex flex-col items-center p-0 cursor-pointer ${answered ? 'opacity-60' : ''}`}
                            onClick={() => handleImageClick(idx)}
                            aria-label={`Vybrat zvíře ${question.optionsWords[idx]}`}
                            tabIndex={0}
                            role="button"
                        >
                            <img
                                src={img}
                                alt={question.optionsWords[idx]}
                                className="w-24 h-24 object-cover rounded-xl"
                            />
                            <div className="hidden text-lg font-semibold text-gray-700 mt-2">{question.optionsWords[idx]}</div>
                        </div>
                    );
                })}
            </div>
            {!answered && (
                <div className="flex justify-center mt-10">
                    <button onClick={handleSubmit} className="btn-primary submit-btn px-8 py-3 text-xl rounded-full shadow-lg flex items-center gap-2 hover:bg-green-600 transition">
                        <Icon name="check_circle" className="text-2xl" /> {t('send-answer')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default AudioSelectPlay;
